export interface RegisterB2BConfig {
  heading: string;
  subheading: string;
}

const registerB2BConfigByFacility: Record<string, RegisterB2BConfig> = {
  "1241": {
    heading: "Zostań naszym partnerem",
    subheading:
      "Jeśli otrzymałeś ten link od Park Wodny w Krakowie S.A. oznacza to, że zostałeś zaproszony do grona przedsiębiorców zamawiających wejściówki jako partner biznesowy.",
  },
  "1243": {
    heading: "Zostań naszym partnerem",
    subheading:
      "Jeśli otrzymałeś ten link od Park Wodny w Krakowie S.A. oznacza to, że zostałeś zaproszony do grona przedsiębiorców zamawiających wejściówki jako partner biznesowy.",
  },
};

export const getRegisterB2BConfig = (facilityId: string): RegisterB2BConfig => {
  return (
    registerB2BConfigByFacility[facilityId] || {
      heading: "Zostań naszym partnerem",
      subheading:
        "Jeśli otrzymałeś zaproszenie do grona przedsiębiorców zamawiających jako partner biznesowy, możesz tutaj złożyć wniosek.",
    }
  );
};
